import type { RefreshRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useRefresh() {
	return useApiMutation(
		"post",
		"/auth/refresh",
		{
			notify: false,
			mapVariables: (data: RefreshRequestDto) => ({
				body: data,
				headers: {
					"x-auth-request": "true",
				},
				credentials: "include",
			}),
		},
	);
}
